// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe[data-v-3f9cb1f8]{height:100%}*[data-v-3f9cb1f8]{overflow:hidden}", ""]);
// Exports
module.exports = exports;
